module.exports = __webpack_public_path__ + "static/media/visa-light.6e631d05.svg";